var map = {
	"./Vector.png": 9385,
	"./about/1.png": 7245,
	"./about/2.jpg": 8626,
	"./about/2.png": 3478,
	"./about/3.png": 8575,
	"./about/4.png": 6352,
	"./about/5.png": 8457,
	"./about/6.png": 4450,
	"./avtar/1.jpg": 6804,
	"./avtar/1.png": 5552,
	"./avtar/2.jpg": 9379,
	"./avtar/3.jpg": 4614,
	"./avtar/4.jpg": 957,
	"./avtar/5.jpg": 9216,
	"./avtar/6.jpg": 9535,
	"./avtar/big/audiocall.jpg": 5292,
	"./avtar/big/videocall.jpg": 8387,
	"./avtar/big/videocall_bg.jpg": 8689,
	"./avtar/contact-profile.jpg": 4177,
	"./avtar/family.jpg": 8609,
	"./avtar/girls.jpg": 8488,
	"./avtar/teq.jpg": 5895,
	"./blog/1.jpg": 1304,
	"./blog/blog-10.jpg": 4635,
	"./blog/blog-11.jpg": 8174,
	"./blog/blog-12.jpg": 4313,
	"./blog/blog-5.jpg": 783,
	"./blog/blog-6.jpg": 464,
	"./blog/blog-7.jpg": 2205,
	"./blog/blog-8.jpg": 5614,
	"./blog/blog-9.jpg": 5771,
	"./blog/blog-detail.jpg": 6667,
	"./blog/small/1.jpg": 9568,
	"./blog/small/2.jpg": 3183,
	"./blog/small/3.jpg": 5250,
	"./blog/small/4.jpg": 3265,
	"./blog/small/5.jpg": 5220,
	"./blog/small/6.jpg": 499,
	"./blog/small/7.jpg": 7334,
	"./blog/small/8.jpg": 4725,
	"./blog/small/9.jpg": 2360,
	"./chat.gif": 9357,
	"./contact/1.jpg": 9590,
	"./contact/2.jpg": 5441,
	"./contact/3.jpg": 3636,
	"./contact/4.jpg": 1919,
	"./contact/5.jpg": 210,
	"./disconnect/2.png": 1073,
	"./disconnect/3.png": 9944,
	"./error/1.png": 6252,
	"./faq.svg": 4898,
	"./favicon/favicon.png": 879,
	"./file_icons/1.jpg": 5697,
	"./file_icons/10.png": 141,
	"./file_icons/11.png": 9012,
	"./file_icons/12.png": 7919,
	"./file_icons/3.png": 5947,
	"./file_icons/4.png": 3956,
	"./file_icons/5.png": 5085,
	"./file_icons/6.png": 1318,
	"./file_icons/7.png": 6415,
	"./file_icons/8.png": 4760,
	"./file_icons/9.png": 7473,
	"./gallery/1.jpg": 3620,
	"./gallery/1_1.jpg": 3116,
	"./gallery/1_2.jpg": 811,
	"./gallery/1_3.jpg": 4350,
	"./gallery/2.jpg": 1427,
	"./gallery/3.jpg": 4966,
	"./gallery/4.jpg": 6077,
	"./gallery/5.jpg": 4944,
	"./gallery/6.jpg": 8559,
	"./gallery/7.jpg": 6178,
	"./gallery/8.jpg": 4889,
	"./gallery/9.jpg": 6844,
	"./gif/Loader.gif": 6159,
	"./gif/sad.gif": 1122,
	"./index/1.png": 9818,
	"./index/2.png": 401,
	"./index/bg.jpg": 1838,
	"./index/client.png": 2718,
	"./index/features/1.png": 6970,
	"./index/features/2.png": 5953,
	"./index/features/3.png": 1336,
	"./index/features/4.png": 2855,
	"./index/features/5.png": 9838,
	"./index/features/6.png": 1637,
	"./index/features/7.png": 2220,
	"./index/home/1.png": 6858,
	"./index/home/2.png": 7969,
	"./index/home/home-main.png": 718,
	"./index/mobile/1.png": 8389,
	"./index/section-bg.jpg": 7396,
	"./index/submit/1.png": 167,
	"./index/team.png": 5528,
	"./landing-page/Vector.png": 9033,
	"./landing-page/dark-logo.png": 9570,
	"./landing-page/footer-bg.png": 5909,
	"./landing-page/responsive-app/bg.png": 9592,
	"./landing-page/responsive-app/figma-file.png": 3310,
	"./landing-page/responsive-app/hand.png": 4866,
	"./landing-page/responsive-app/pretty-printed.png": 7712,
	"./landing-page/slicing/1.jpg": 4209,
	"./landing-page/support/0.png": 2498,
	"./landing-page/support/1.png": 7323,
	"./landing-page/threeinonepage/app.png": 7614,
	"./landing-page/threeinonepage/email.png": 7111,
	"./landing-page/threeinonepage/landing-page.png": 36,
	"./landing/chatzy/2.png": 4554,
	"./landing/footer/2.png": 3846,
	"./landing/home/app.jpg": 2985,
	"./landing/home/landing-page.jpg": 9369,
	"./landing/parallax/main.png": 9297,
	"./landing/pricing-plan/1.png": 6486,
	"./landing/pricing-plan/2.png": 1373,
	"./landing/pricing-plan/3.png": 244,
	"./landing/testimonial/icon1.png": 2178,
	"./landing/testimonial/icon2.png": 3145,
	"./landing/testimonial/icon3.png": 8672,
	"./login_signup/01.png": 9958,
	"./login_signup/02.png": 1725,
	"./logo/landing-logo.png": 1925,
	"./logo/logo-2.png": 5426,
	"./logo/logo-white-1.png": 505,
	"./logo/logo-white-2.png": 9538,
	"./logo/logo-white.png": 6719,
	"./logo/logo.png": 6447,
	"./logo/logo_big.png": 6092,
	"./logo/maximize.svg": 8312,
	"./status-img/large/lg-1.jpg": 6172,
	"./status-img/large/lg-2.jpg": 2619,
	"./status-img/large/lg-3.jpg": 7838,
	"./status-img/large/lg-4.jpg": 2309,
	"./status-img/large/lg-5.jpg": 7563,
	"./status-img/large/lg-6.jpg": 519,
	"./status-img/large/lg-7.jpg": 9706,
	"./status-img/small/sm-1.jpg": 7855,
	"./status-img/small/sm-2.jpg": 4240,
	"./status-img/small/sm-3.jpg": 5373,
	"./status-img/small/sm-4.jpg": 614,
	"./status-img/small/sm-5.jpg": 7075,
	"./status-img/small/sm-6.jpg": 2916,
	"./status-img/small/sm-7.jpg": 961,
	"./sticker/1.gif": 4244,
	"./sticker/10.gif": 484,
	"./sticker/11.gif": 333,
	"./sticker/12.gif": 9794,
	"./sticker/13.gif": 2571,
	"./sticker/14.gif": 1328,
	"./sticker/15.gif": 2937,
	"./sticker/16.gif": 6750,
	"./sticker/17.gif": 5287,
	"./sticker/18.gif": 9084,
	"./sticker/19.gif": 1301,
	"./sticker/2.gif": 7387,
	"./sticker/20.gif": 901,
	"./sticker/21.gif": 2236,
	"./sticker/22.gif": 9283,
	"./sticker/23.gif": 9690,
	"./sticker/24.gif": 3745,
	"./sticker/25.gif": 9128,
	"./sticker/26.gif": 2863,
	"./sticker/27.gif": 7990,
	"./sticker/28.gif": 9309,
	"./sticker/29.gif": 612,
	"./sticker/3.gif": 8082,
	"./sticker/30.gif": 7710,
	"./sticker/31.gif": 2327,
	"./sticker/32.gif": 8976,
	"./sticker/33.gif": 1177,
	"./sticker/34.gif": 7714,
	"./sticker/35.gif": 7019,
	"./sticker/36.gif": 7524,
	"./sticker/37.gif": 157,
	"./sticker/38.gif": 8838,
	"./sticker/39.gif": 6751,
	"./sticker/4.gif": 1545,
	"./sticker/40.gif": 5727,
	"./sticker/41.gif": 1990,
	"./sticker/42.gif": 4705,
	"./sticker/43.gif": 2344,
	"./sticker/5.gif": 5696,
	"./sticker/6.gif": 9047,
	"./sticker/7.gif": 4430,
	"./sticker/8.gif": 6117,
	"./sticker/9.gif": 6492,
	"./to-do.gif": 2874,
	"./wallpaper/1.jpg": 3216,
	"./wallpaper/1.png": 4020,
	"./wallpaper/2.jpg": 6831,
	"./wallpaper/3.jpg": 2069,
	"./wallpaper/4.jpg": 9937,
	"./wallpaper/5.jpg": 1892,
	"./wallpaper/6.jpg": 6051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4002;